
(function () {

  function initRydaTrustBars(scope) {

    var root = scope || document;

    var bars = [];


    if (
      root.matches &&
      root.matches('.ryda-trustbar')
    ) {

      bars.push(root);

    }


    if (root.querySelectorAll) {

      var foundBars =
        root.querySelectorAll(
          '.ryda-trustbar'
        );


      foundBars.forEach(function (bar) {

        bars.push(bar);

      });

    }


    bars.forEach(function (bar) {

      if (
        bar.getAttribute(
          'data-ryda-ready'
        ) === 'true'
      ) {

        return;

      }


      var track =
        bar.querySelector(
          '.ryda-trustbar__track'
        );


      var slides =
        bar.querySelectorAll(
          '.ryda-trustbar__item'
        );


      var prevButton =
        bar.querySelector(
          '.ryda-trustbar__arrow--prev'
        );


      var nextButton =
        bar.querySelector(
          '.ryda-trustbar__arrow--next'
        );


      if (
        !track ||
        !slides.length ||
        !prevButton ||
        !nextButton
      ) {

        return;

      }


      var current = 0;

      var total = slides.length;

      var autoTimer = null;


      /* =====================================================
         AUTO SPEED
         ===================================================== */

      var autoSpeed =
        parseInt(
          bar.getAttribute(
            'data-auto-speed'
          ),
          10
        );


      if (
        !autoSpeed ||
        autoSpeed < 1500
      ) {

        autoSpeed = 3500;

      }


      var reduceMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );


      /* =====================================================
         UPDATE
         ===================================================== */

      function updateSlider() {

        if (
          window.innerWidth <= 989
        ) {

          track.style.transform =
            'translate3d(-' +
            (current * 100) +
            '%, 0, 0)';

        } else {

          track.style.transform = '';

        }

      }


      /* =====================================================
         NEXT
         ===================================================== */

      function nextSlide() {

        current += 1;


        if (
          current >= total
        ) {

          current = 0;

        }


        updateSlider();

      }


      /* =====================================================
         PREVIOUS
         ===================================================== */

      function prevSlide() {

        current -= 1;


        if (
          current < 0
        ) {

          current =
            total - 1;

        }


        updateSlider();

      }


      /* =====================================================
         STOP AUTO
         ===================================================== */

      function stopAuto() {

        if (
          autoTimer !== null
        ) {

          clearInterval(
            autoTimer
          );


          autoTimer = null;

        }

      }


      /* =====================================================
         START AUTO — MOBILE ONLY
         ===================================================== */

      function startAuto() {

        stopAuto();


        if (
          window.innerWidth <= 989 &&
          !reduceMotion.matches
        ) {

          autoTimer =
            window.setInterval(
              nextSlide,
              autoSpeed
            );

        }

      }


      /* =====================================================
         RIGHT ARROW
         ===================================================== */

      nextButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          nextSlide();

          startAuto();

        }
      );


      /* =====================================================
         LEFT ARROW
         ===================================================== */

      prevButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          prevSlide();

          startAuto();

        }
      );


      /* =====================================================
         RESIZE
         ===================================================== */

      window.addEventListener(
        'resize',
        function () {

          updateSlider();

          startAuto();

        }
      );


      /* =====================================================
         TAB VISIBILITY
         ===================================================== */

      document.addEventListener(
        'visibilitychange',
        function () {

          if (
            document.hidden
          ) {

            stopAuto();

          } else {

            startAuto();

          }

        }
      );


      bar.setAttribute(
        'data-ryda-ready',
        'true'
      );


      updateSlider();

      startAuto();

    });

  }


  /* =========================================================
     NORMAL PAGE LOAD
     ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initRydaTrustBars(
          document
        );

      }
    );

  } else {

    initRydaTrustBars(
      document
    );

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initRydaTrustBars(
        event.target
      );

    }
  );

})();
